import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button, Stack, Autocomplete } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Colors } from "../../../Styles/Colors";
import { useHistory } from 'react-router-dom'
import { ImagePaths } from "../../../Utility/ImagePaths";
import CommonGridHeader, { CommonGridToolBarWithFilterText } from "../../../Components/Common Components/CommonComponents";
import { AmountsCard } from "../../../Components/CommonCards/CommonCards";
import { AmountFormat, CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import { CurrencySymbol } from "../../../Utility/Constants";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { useLocation } from 'react-router-dom'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { DateTime } from "luxon";

function StoreCreditNoteAdd() {
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [vendorList, setVendorList] = useState([]);
    const [vendor, setVendor] = useState(null);
    const [creditNumber, setCreditNumber] = useState('');
    const [creditId, setCreditId] = useState(null);
    const [creditDate, setCreditDate] = useState(new Date());
    const [vendorRtnData, setvendorRtnData] = useState([]);
    const [overallAmt, setOverallAmt] = useState({
        bill_amount: 0,
        excluded_amount: 0,
        gst_amount: 0,
    });
    const [isEdit, setisEdit] = useState(false);
    const [isloader, setisloader] = useState(false);
    const [disableBtn, setDisbleBtn] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const EditAccess = CheckAccessFunc("Store", "Purchase", "Credit Note", null, "Tab")?.editAccess
    

    useEffect(() => {
        if (location?.states?.credit_note_data) {
            let Data = location?.states?.credit_note_data
            setOverallAmt({
                bill_amount: +Data?.total_amount || 0,
                excluded_amount: +Data?.net_amount || 0,
                gst_amount: +Data?.gst_amount || 0,
            })

            let LineItem = []
            Data?.line_items?.forEach((item) => {
                LineItem.push({
                    selected: true,
                    return_date: item?.return_date || "-",
                    return_number: item?.return_number || "-",
                    hsn_code: item?.hsn_code || "-",
                    product_name: item?.product_name || "-",
                    product_type_name: item?.product_type_name || "-",
                    category_name: item?.category_name || "-",
                    batch_no: item?.batch_no || "-",
                    expiry_date: item?.expiry_date || "-",
                    return_quantity: +item?.return_quantity || 0,
                    purchase_rate_per_qty: +item?.purchase_rate_per_qty || 0,
                    credit_qty: +item?.credit_quantity || 0,
                    credit_value: +item?.credit_rate_quantity || 0,
                    excluded_amount: +item?.total_amount || 0,
                    gst_amount: +item?.gst_amount || 0,
                    gst_percentage: +item?.gst_percentage || 0,
                    bill_amount: +item?.net_amount || 0,
                    id: item?.id || null,
                    return_line_id: item?.return_line_id || null,
                })
            })
            setvendorRtnData(LineItem)
            setCreditNumber(Data?.credit_number)
            setCreditId(Data?.credit_id || null)
            const dateString = Data?.credit_date
            const parts = dateString?.split('-')
            setCreditDate(Data?.credit_date ? new Date(parts[2], parts[1] - 1, parts[0]) : new Date())
            setisEdit(true)
            getVendorList(Data?.vendor_id)
        } else {
            getVendorList()
        }
    }, [])

    useEffect(() => {
        if (vendor?.id && !isEdit) {
            getPurchaseRejectionData()
        }
    }, [vendor])

    useEffect(() => {
        setOverallAmt((prevData) => ({
            ...prevData,
            bill_amount: vendorRtnData.reduce((acc, vendor) => acc + (vendor.bill_amount ? +vendor.bill_amount : 0), 0),
            excluded_amount: vendorRtnData.reduce((acc, vendor) => acc + (vendor.excluded_amount ? +vendor.excluded_amount : 0), 0),
            gst_amount: vendorRtnData.reduce((acc, vendor) => acc + (vendor.gst_amount ? +vendor.gst_amount : 0), 0),
        }))
    }, [vendorRtnData]);

    const getVendorList = (VendorId = null) => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_VENDOR)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setVendorList(response.data.data || [])
                        if (VendorId) {
                            setVendor(response?.data?.data?.find((list) => list?.id === VendorId))
                        }
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getPurchaseRejectionData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(`${Serviceurls.STORE_CREDIT_NOTE_VENDOR_SEARCH}?vendor_id=${vendor?.id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setvendorRtnData(response.data.data || [])
                        if (response.data.data?.length === 0) {
                            errorMessage("No Rejection data found for this vendor")
                        }
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const errorMessage = (msg) => {
        setDisbleBtn(false)
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const handleCheckChange = (id) => {
        setvendorRtnData((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? {
                    ...row,
                    selected: !row.selected,
                    credit_qty: "",
                    credit_value: "",
                    gst_amount: "",
                    bill_amount: "",
                    excluded_amount: "",
                } : row
            )
        );
    }

    console.log(vendorRtnData);


    const tableView = () => {
        try {
            vendorRtnData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: "select",
                    headerName: "",
                    flex: 0.03,
                    renderCell: (params) => (
                        <Checkbox
                            disabled={!params?.row?.return_quantity || isEdit}
                            checked={params.row.selected || false}
                            onChange={() => handleCheckChange(params.row.id)}
                        />
                    ),
                },
                {
                    field: 'return_date', headerName: 'Rejection Date', flex: 0.09,
                    renderCell: (params) => (<Box>{params?.row?.return_date ? params?.row?.return_date : '-'}</Box>)
                },
                {
                    field: 'return_number', headerName: 'Rejection No', flex: 0.09,
                    renderCell: (params) => (<Box>{params?.row?.return_number ? params?.row?.return_number : '-'}</Box>)
                },
                {
                    field: 'hsn_code', headerName: 'HSN Code', flex: 0.09,
                    renderCell: (params) => (<Box>{params?.row?.hsn_code ? params?.row?.hsn_code : '-'}</Box>)
                },
                {
                    field: 'drug_name', headerName: 'Products Details', flex: 0.15,
                    renderCell: (params) => {
                        let brandName = params?.row?.product_name
                        let drugDetails = (params?.row?.product_type_name ? params?.row?.product_type_name : '-') + "|" + (params?.row?.category_name ? params?.row?.category_name : '-')
                        return (
                            <Box>
                                {brandName ? brandName?.length > 15 ?
                                    <Tooltip placement='top' title={brandName}><Typography fontSize={'0.8vw'} fontWeight={600}>{brandName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={'0.8vw'} fontWeight={600}>{brandName}</Typography> : '-'}
                                {drugDetails ? drugDetails?.length > 15 ?
                                    <Tooltip placement='top' title={drugDetails}><Typography color={Colors.grayShade} fontSize={'0.8vw'}>{drugDetails?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography color={Colors.grayShade} fontSize={'0.8vw'}>{drugDetails ? drugDetails : '-'}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'batch_no', headerName: 'Batch No', flex: 0.09,
                    renderCell: (params) => (<Box>{params?.row?.batch_no ? params?.row?.batch_no : '-'}</Box>)
                },
                {
                    field: 'expiry_date', headerName: 'Expiry Date', flex: 0.09,
                    renderCell: (params) => (<Box>{params?.row?.expiry_date ? (isEdit ? params?.row?.expiry_date : formatDate(params?.row?.expiry_date, true)) : '-'}</Box>)
                },
                {
                    field: 'return_quantity', headerName: 'Return Qty', flex: 0.09, type: "number",
                    renderCell: (params) => (<Box>{params?.row?.return_quantity ? params?.row?.return_quantity : '-'}</Box>)
                },
                {
                    field: 'purchase_rate_per_qty', headerName: 'Purchase Value', flex: 0.09, type: "number",
                    renderCell: (params) => (<Box>{AmountFormat((params?.row?.purchase_rate_per_qty) || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
                },
                {
                    field: 'credit_qty', headerName: 'Credit Qty', flex: 0.09,
                    renderCell: (params) => {
                        return (
                            <TextField
                                disabled={params?.row?.selected ? false : true}
                                size="small"
                                inputProps={{ style: { height: '4vh', padding: '0 14px' } }}
                                autoComplete='off'
                                value={params.row?.credit_qty ? params.row?.credit_qty : ""}
                                onChange={(e) => {
                                    if (e.target.value === "" || (CommonValidation.numberOnly(e.target.value) && e.target.value?.length <= 10)) {
                                        setvendorRtnData((prevRows) =>
                                            prevRows.map((row) =>
                                                row.id === params.row.id ? {
                                                    ...row,
                                                    credit_qty: e.target?.value ? (row?.return_quantity >= +e.target?.value ? e.target?.value : row?.credit_qty) : 0,
                                                    gst_amount: e.target?.value ? ((+e.target?.value && row?.gst_percentage && row?.credit_value && row?.return_quantity >= +e.target?.value) ? (((+e.target?.value * (+row?.credit_value ? +row?.credit_value : 1)) * (+row?.gst_percentage ? +row?.gst_percentage : 1)) / 100) : row?.gst_amount) : 0,
                                                    bill_amount: e.target?.value ? ((row?.credit_value && e.target?.value && row?.return_quantity >= +e.target?.value) ? (+e.target?.value * (+row?.credit_value ? +row?.credit_value : 0)) : +row?.bill_amount) + ((+e.target?.value && row?.gst_percentage && row?.return_quantity >= +e.target?.value) ? ((row?.gst_percentage && e.target?.value && row?.credit_value) ? ((+e.target?.value * +row?.credit_value) * (+row?.gst_percentage) / 100) : 0) : 0) : 0,
                                                    excluded_amount: e.target?.value ? ((row?.credit_value && e.target?.value && row?.return_quantity >= +e.target?.value) ? (+e.target?.value * (+row?.credit_value ? +row?.credit_value : 0)) : row?.excluded_amount) : 0,
                                                } : row
                                            )
                                        );
                                    }
                                }}
                                className='eMed_DataGrid_TextField' />
                        )
                    }
                },
                {
                    field: 'credit_value', headerName: 'Credit Value', flex: 0.09,
                    renderCell: (params) => (
                        <Box component={'div'}>
                            <TextField
                                disabled={params?.row?.selected ? false : true}
                                inputProps={{ style: { height: '4vh', padding: '0 14px' } }}
                                autoComplete='off'
                                size="small"
                                value={params.row?.credit_value ? params.row?.credit_value : ""}
                                onChange={(e) => {
                                    if (e.target.value === "" || (CommonValidation.DecimalNumber(e.target.value) && e.target.value?.length <= 10)) {
                                        setvendorRtnData((prevRows) =>
                                            prevRows.map((row) =>
                                                row.id === params.row.id ? {
                                                    ...row,
                                                    credit_value: e.target?.value ? (row?.purchase_rate_per_qty >= +e.target?.value ? e.target?.value : row?.credit_value) : 0,
                                                    gst_amount: e.target?.value ? ((+row?.credit_qty && row?.gst_percentage && e.target.value && row?.purchase_rate_per_qty >= +e.target?.value) ? (((+row?.credit_qty * (+e.target.value)) * (+row?.gst_percentage ? +row?.gst_percentage : 1)) / 100) : row?.gst_amount) : 0,
                                                    bill_amount: e.target?.value ? ((e.target.value && row?.credit_qty && row?.purchase_rate_per_qty >= +e.target?.value) ? (+row?.credit_qty * (+e.target.value)) : 0) +
                                                        ((+row?.credit_qty && row?.gst_percentage && row?.purchase_rate_per_qty >= +e.target?.value) ? ((row?.gst_percentage && row?.credit_qty && e.target.value) ? ((+row?.credit_qty * +e.target.value) * (+row?.gst_percentage) / 100) : 0) : row?.bill_amount) : 0,
                                                    excluded_amount: e.target?.value ? (e.target.value && row?.credit_qty && row?.purchase_rate_per_qty >= +e.target?.value) ? (+row?.credit_qty * (+e.target.value)) : row?.excluded_amount : 0,
                                                } : row
                                            )
                                        );
                                    }
                                }}
                                className='eMed_DataGrid_TextField' />
                        </Box>
                    )
                },
                {
                    field: 'excluded_amount', headerName: 'Total (Excl)', flex: 0.09, type: "number",
                    renderCell: (params) => (
                        <Box>{AmountFormat(+(params?.row?.excluded_amount) || 0)?.replace(`${CurrencySymbol}`, "")}</Box>
                    )
                },
                {
                    field: 'gst_percentage', headerName: 'GST', flex: 0.09, headerAlign: 'center', align: 'center',
                    renderCell: (params) => (
                        <Box>
                            <Typography>{params?.row?.gst_amount ? +(params?.row?.gst_amount).toFixed(2) : 0}</Typography>
                            <Typography fontSize={'0.8vw'} align='right'>{params?.row?.gst_percentage ? params?.row?.gst_percentage + "%" : "0%"}</Typography>
                        </Box>)
                },
                {
                    field: 'bill_amount', headerName: 'Net Total', flex: 0.09, type: "number",
                    renderCell: (params) => (<Box>{AmountFormat(params?.row?.bill_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
                },
            ];
            return (
                <Box sx={{ height: '64vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        sx={{ background: Colors.white }}
                        rows={vendorRtnData}
                        page={page}
                        pageSize={pageSize}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: CommonGridHeader.CommonToolBar,
                            NoRowsOverlay: () => (
                                <Box className='eMed_conf_nodata'>
                                    {("No Records To Be Shown")}
                                </Box>
                            )
                        }}
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    const postCreditNote = () => {
        try {
            if (!vendor?.id || !creditNumber) {
                errorMessage('Please Enter All mandatory fields')
            }
            else {
                let LineItems = []
                vendorRtnData?.forEach((list) => {
                    if (list?.credit_qty && list?.credit_value)
                        LineItems.push({
                            "id": isEdit ? (list?.id || null) : null,
                            "return_line_id": list?.return_line_id || null,
                            "credit_quantity": +list?.credit_qty || 0,
                            "credit_rate_quantity": +list?.credit_value || 0,
                            "total_amount": list?.excluded_amount ? +(list?.excluded_amount).toFixed(2) : 0,
                            "net_amount": list?.bill_amount ? +(list?.bill_amount).toFixed(2) : 0,
                            "gst_amount": list?.gst_amount ? +(list?.gst_amount).toFixed(2) : 0,
                            "gst_percentage": +list?.gst_percentage || 0,
                        })
                })
                let startDate = new Date(creditDate)
                let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
                let data = {
                    "vendor_id": vendor?.id || null,
                    "credit_id": isEdit ? (creditId || null) : null,
                    "credit_number": creditNumber || "",
                    "credit_date": creditDate ? date : "",
                    "total_amount": overallAmt?.bill_amount ? +(overallAmt?.bill_amount).toFixed(2) : 0,
                    "net_amount": overallAmt?.excluded_amount ? +(overallAmt?.excluded_amount).toFixed(2) : 0,
                    "gst_amount": overallAmt?.gst_amount ? +(overallAmt?.gst_amount).toFixed(2) : 0,
                    "line_items": LineItems
                }
                RestAPIService.create(data, Serviceurls.STORE_CREDIT_NOTE)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            history.push({ pathname: '/StorePurchase/CreditNote', states: { success_message: response.data.message } })
                        }
                    }).catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    return (
        <Box>
            <Box component={'div'} className='eMed_Pharma_Header_Card'>
                <Stack direction="row" spacing={1} alignItems="center"><IconButton size="small" onClick={() => {
                    history.push({ pathname: '/StorePurchase/CreditNote' })
                }} ><img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} /></IconButton><Typography sx={{ color: "#616161" }}> {"Back to Credit Note"}</Typography></Stack>
            </Box>
            <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} height={'13vh'} justifyContent={'space-between'}>
                    <Box display={'flex'} flexDirection={'row'}>
                        <Box component={'div'} mr={'1vw'}>
                            <Autocomplete
                                disableClearable
                                disabled={isEdit}
                                size='small'
                                sx={{ width: '20vw' }}
                                options={vendorList}
                                getOptionLabel={(options) => typeof (options) === 'string' ? options : options.vendor_name}
                                value={vendor}
                                onChange={(e, value) => {
                                    setVendor(value)
                                }}
                                renderInput={(params) => <TextField {...params} disabled={isEdit} label='Select Vendor *' autoComplete='off' />}
                            />
                        </Box>
                        <Box component={'div'} mr={'1vw'}>
                            <TextField
                                size='small'
                                sx={{ width: '15vw' }}
                                label='Credit Number *'
                                inputProps={{ maxLength: 40 }}
                                value={creditNumber}
                                disabled={isEdit}
                                onChange={(e) => { setCreditNumber(e.target.value) }}
                                autoComplete='off'
                            />
                        </Box>
                        <Box component={'div'} mr={'1vw'}>
                            <Box>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={creditDate ? creditDate : null}
                                        name={"datePicker"}
                                        inputFormat='DD-MM-YYYY'
                                        views={["year", "month", "day"]}
                                        onChange={(newDate) => {
                                            setCreditDate(newDate);
                                        }}
                                        disabled={isEdit}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            label={"Date"}
                                            variant="outlined"
                                            onKeyDown={(e) => e.preventDefault()}
                                            disabled={isEdit}
                                            sx={{ width: '15dvw' }}
                                            size='small'
                                        />}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Box>
                        <Box component={'div'} mr={'1vw'} display={'flex'} alignItems={'center'}>
                            <Button size="small" disabled={vendorRtnData?.length === 0 || !EditAccess} variant="contained" onClick={() => postCreditNote()} sx={{ textTransform: 'capitalize' }}>{isEdit ? `Update` : `Generate`}</Button>
                        </Box>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'}>
                        {AmountsCard("Total (Excluding GST)", overallAmt?.excluded_amount, false, "white", false, null, 'creditNote_totalnetAmt')}
                        {AmountsCard("Total GST", overallAmt?.gst_amount, false, "white", false, null, 'creditNote_totalTaxableAmt')}
                        {AmountsCard("Net Total", overallAmt?.bill_amount, false, "white", false, null, 'creditNote_total')}
                    </Box>
                </Box>
                <Box>
                    {tableView()}
                </Box>
                {errorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={errorMsgText}
                        msgPop={msgClose.bind(this)}
                    />
                    : null}
                {successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={successMsgText}
                        msgPop={msgClose.bind(this)}
                    />
                    : null}
                {console.log(creditDate)}
            </Box>
        </Box>

    );
};

export default StoreCreditNoteAdd;
